import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { msalConfig } from "../config/msalConfig";
import {
  InteractionType,
  RedirectRequest,
} from "@azure/msal-browser";
import { USER_AUTH_TYPE } from "../enums/user-auth-type.enum";
import Dashboard from "./Dashboard";
import Welcome from "../components/Welcome";
import LoadingPlaceholder from "../components/LoadingPlaceholder";
import { createMsalInstance } from "../utils/create-msal-instance";

export default function Invite() {
  const location = useLocation();
  const navigate = useNavigate();
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [params, setParams] = useState<{
    ownerId: string;
    employeeId: string;
  } | null>(null);

  useEffect(() => {
    instance.initialize();
    const query = new URLSearchParams(location.search);
    const ownerId = query.get("ownerId") as string;
    const employeeId = query.get("employeeId") as string;
    setParams({ ownerId, employeeId });

    const authenticate = async () => {
      try {
        localStorage.setItem("ownerId", ownerId);
        localStorage.setItem("employeeId", employeeId);
        const loginRequest: RedirectRequest = {
          authority: `${process.env.REACT_APP_MSAL_AUTHORITY}/${USER_AUTH_TYPE.COMARCH_EMPLOYEE}`,
          scopes: msalConfig.auth.scopes,
          redirectStartPage: `${process.env.REACT_APP_BASE_URL}/invite`,
        };

        msalConfig.auth.redirectUri =
          process.env.REACT_APP_MSAL_INVITE_REDIRECT_URI || "";
        const msalInstance = await createMsalInstance();
        const res = await msalInstance.loginRedirect(loginRequest);
      } catch (error) {
        localStorage.removeItem("ownerId");
        localStorage.removeItem("employeeId");
        console.error(error);
      }
    };

    if (inProgress === InteractionType.None) {
      if (ownerId && employeeId && !isAuthenticated) {
        authenticate();
      }
    }
  }, [inProgress, instance, isAuthenticated, location, navigate]);

  return (
    <>
      {!isAuthenticated ? (
        <>
          {params?.ownerId && params?.employeeId ? (
            <p className="text-center mt-5">Authenticating...</p>
          ) : (
            <>
              {inProgress === InteractionType.None ? (
                <Welcome />
              ) : (
                <LoadingPlaceholder />
              )}
            </>
          )}
        </>
      ) : (
        <>
          {(localStorage.getItem('ownerId') || params?.ownerId) ? <Dashboard /> : <Welcome />}
        </>
      )}
    </>
  );
}
